import { useState } from 'react';
import ApplicationModal from './ApplicationModal';

export default function ApplySection() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleApply = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <section id="apply" className="py-24 bg-gradient-to-br from-pink-50 via-rose-50 to-orange-50">
        <div className="max-w-7xl mx-auto px-6">
          {/* 申込対象者セクション */}
          <div className="mb-20">
            <div className="text-center mb-12">
              <div className="inline-block bg-rose-100 px-6 py-2 rounded-full mb-6">
                <span className="text-sm font-bold text-rose-600 tracking-wider">
                  REQUIREMENTS
                </span>
              </div>
              <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
                申込対象者
              </h2>
            </div>

            <div className="max-w-4xl mx-auto bg-gradient-to-br from-rose-50 to-pink-50 rounded-3xl p-12 shadow-xl">
              <div className="space-y-6 mb-8">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-rose-500 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <p className="text-lg text-gray-800 leading-relaxed pt-1">
                    ベース・トップジェル、カラージェルなど、サロンのメインユーズがMiss Mirage商材である
                  </p>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-rose-500 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <p className="text-lg text-gray-800 leading-relaxed pt-1">
                    サロンワーク経験が3年以上である
                  </p>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-8 h-8 bg-rose-500 rounded-full flex items-center justify-center">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <p className="text-lg text-gray-800 leading-relaxed pt-1">
                    ジェルネイル技能検定 2級以上
                  </p>
                </div>
              </div>

              <div className="border-t border-rose-200 pt-8">
                <p className="text-base text-gray-700 leading-relaxed">
                  Miss Mirage エデュケーターでは、検定対策指導及び、サロンワーク即戦力のネイリストを育成ができるエデュケーターになることを目的としています。
                </p>
              </div>
            </div>
          </div>

          {/* 既存の申込セクション */}
          <div className="grid grid-cols-1 lg:grid-cols-2 rounded-3xl overflow-hidden shadow-2xl">
            <div className="relative bg-rose-50 p-16 flex flex-col justify-center">
              <div
                className="absolute inset-0 bg-cover bg-center opacity-20"
                style={{
                  backgroundImage: 'url(https://public.readdy.ai/ai/img_res/f3abaece5ca671ecf1cb6a4113dc8465.jpg)',
                }}
              ></div>

              <div className="relative z-10">
                <div className="inline-block bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
                  <span className="text-sm font-bold text-rose-600 tracking-wider">
                    START YOUR JOURNEY
                  </span>
                </div>

                <h2 className="text-5xl lg:text-6xl font-black text-gray-900 leading-tight">
                  今すぐ、<br />
                  エデュケーターへの<br />
                  第一歩を
                </h2>
              </div>
            </div>

            <div className="bg-gradient-to-br from-pink-50 via-rose-50 to-pink-100 p-16 flex flex-col justify-center items-center text-center">
              <h3 className="text-4xl font-bold text-gray-900 mb-6">
                お申し込み
              </h3>

              <p className="text-gray-600 leading-relaxed mb-12 max-w-md">
                プログラムの詳細や、あなたに最適なコース選択について、専門スタッフが丁寧にご説明いたします。お気軽にお問い合わせください。
              </p>

              <button
                onClick={handleApply}
                className="inline-flex items-center space-x-3 px-10 py-5 bg-gradient-to-r from-amber-800 to-amber-900 text-white text-base sm:text-lg font-bold rounded-full hover:shadow-2xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
              >
                <span>お申し込みボタン（準備中）</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      <ApplicationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}